import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import { TextStyle } from '@tiptap/extension-text-style';
import Color from '@tiptap/extension-color';
import TextAlign from '@tiptap/extension-text-align';
import styles from './BriefViewer.module.css';

const EXTENSIONS = [
  StarterKit.configure({
    heading: { levels: [1, 2, 3] },
    blockquote: {},
    bulletList: {},
    orderedList: {},
    listItem: {},
    bold: {},
    italic: {},
    strike: {}
  }),
  Underline,
  Link.configure({
    openOnClick: false,
    HTMLAttributes: { target: '_blank', rel: 'noopener noreferrer' }
  }),
  TextStyle,
  Color,
  TextAlign.configure({
    types: ['heading', 'paragraph'],
    alignments: ['left', 'center', 'right', 'justify'],
    defaultAlignment: null
  })
];

interface BriefViewerProps {
  html: string;
  className?: string;
}

export function BriefViewer({ html, className }: BriefViewerProps) {
  const editor = useEditor({
    extensions: EXTENSIONS,
    content: html,
    editable: false,
    immediatelyRender: false
  });

  return (
    <EditorContent
      editor={editor}
      className={`${styles.briefViewer}${className ? ` ${className}` : ''}`}
    />
  );
}
